import { render, staticRenderFns } from "./ListCastes.vue?vue&type=template&id=73063eb3&"
import script from "./ListCastes.vue?vue&type=script&lang=js&"
export * from "./ListCastes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports